import React from 'react';
import { motion } from 'framer-motion';
export function WhyNowSection() {
  return <section className="w-full bg-[#FAF6F0] py-20 px-6 md:px-8" data-id="element-200">
      <div className="max-w-3xl mx-auto text-center" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-202">
          <h2 className="font-serif text-3xl md:text-4xl text-[#1B2141] mb-8" data-id="element-203">
            Por qué funciona “ahora”
          </h2>

          <div className="text-xl text-[#2D2D2D] leading-relaxed space-y-6" data-id="element-204">
            <p data-id="element-205">
              Porque el mayor problema no es tu cama. <br data-id="element-206" />
              Es lo que pasa{' '}
              <span className="font-bold text-[#1B2141]" data-id="element-207">
                después del despertar
              </span>
              .
            </p>

            <p data-id="element-208">Cuando tienes una secuencia clara:</p>

            <div className="inline-block text-left bg-white p-6 rounded-xl shadow-sm border border-[#E8E0D4] mx-auto" data-id="element-209">
              <ul className="space-y-3" data-id="element-210">
                {['Baja la ansiedad', 'Baja la pelea interna', 'Baja el tiempo despierta (con práctica)', 'Vuelve la sensación de control'].map((item, i) => <li key={i} className="flex items-center text-lg" data-id="element-211">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#C9A96E] mr-3" data-id="element-212"></span>
                    {item}
                  </li>)}
              </ul>
            </div>

            <p className="font-serif text-2xl text-[#1B2141] italic pt-4" data-id="element-213">
              Y eso solo ya cambia el día siguiente.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}